import styled from 'styled-components';

export const ContactMap = styled.div`
  padding: 50px 0 0;

  .gm-style {
    .gm-style-iw-c {
      direction: ltr;
    }
    .gm-style-iw-t {
      top: -46px;
    }
  }
  .map_section {
    height: 600px;
    @media (max-width: 767.98px) {
      max-width: 100%;
      margin: 20px 0;
      height: 360px;
    }
    @media (max-width: 350px) {
      max-width: 100%;
      margin: 15px 0;
    }
  }
`;

export const LocationCaption = styled.div`
  position: relative;
  text-align: center;

  h2 {
    line-height: 30px;
    margin-bottom: 1.5rem;
    color: #4a4a4a;

    @media (max-width: 1200px) {
      font-size: 18px;
    }
    @media (max-width: 767.98px) {
      font-size: 20px;
    }
  }
`;

export const MapSection = styled.div`
  max-width: 100%;
  margin: 30px auto;
  height: 500px;
  @media (max-width: 767.98px) {
    margin: 20px auto;
    height: 360px;
  }

  .gm-style {
    .gm-style-iw-c {
      direction: ltr;
    }
    .gm-style-iw-t {
      top: -46px;
    }
    .card-board-link {
      color: #1b7bdd;
      text-align: center;
      display: block;

      &:hover {
        text-decoration: underline;
      }
    }
  }
  &[dir='rtl'] {
    button {
      &.gm-ui-hover-effect {
        left: -6px !important;
      }
    }
    .map-text {
      font-weight: 600 !important;
    }
  }

  iframe {
    padding: 0px !important;
  }
`;
